import { makeStyles } from '@material-ui/core';

import { BANNER_WEBINAR_HEIGHT, BANNER_PERFORMANCE_PREDICTIONS_HEIGHT } from 'src/data/ui';
import { BANNER_TYPE } from '../../lib';

export const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      height: '100vh',
      width: '100%',

      '@media screen and (max-width: 450px)': {
        height: '100dvh',
      },

      [`&[data-banner-type="${BANNER_TYPE.webinar}"]`]: {
        '& $navigationSidebarPanel': {
          marginTop: BANNER_WEBINAR_HEIGHT,
        },
        '& $content': {
          marginTop: BANNER_WEBINAR_HEIGHT,
        },
      },
      [`&[data-banner-type="${BANNER_TYPE.performancePredictions}"]`]: {
        '& $navigationSidebarPanel': {
          marginTop: BANNER_PERFORMANCE_PREDICTIONS_HEIGHT,
        },
        '& $content': {
          marginTop: BANNER_PERFORMANCE_PREDICTIONS_HEIGHT,
        },
      },
    },

    banner: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
    },
    navigationSidebarPanel: {},
    content: {
      flex: '1 1 auto',
      overflow: 'auto',
    },
    overflowHidden: {
      overflow: 'hidden',
    },
  }),
  { name: 'PrivateRouteWrapper' }
);
